import React, { useState, useEffect } from 'react';
import { Input, List, Typography } from 'antd';
import { StarFilled, StarOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import httpInjectorService from 'services/http-injector.service';
import { useParams } from 'react-router-dom';
import SkeletonWithLoaders from 'components/common/Spinner';

const { Text } = Typography;

const StarredPages = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const { spaceid } = useParams();

  const handleStarToggle = (id) => {
    const updated = data.map((item) =>
      item.id === id ? { ...item, starred: !item.starred } : item,
    );
    setData(updated);
  };

  const getStarrenContent = async () => {
    setLoading(true);
    try {
      const response = await httpInjectorService.getStarredContent(spaceid);

      const apiData = response?.data || [];

      const formatted = apiData.map((item) => ({
        id: item.item_id,
        title: item.title || 'Untitled',
        status: item.status,
        item_type:item.item_type,
        starred: item.is_stared === 1,
        pageUrl: `${window.location.origin}/admin/confluence/space/${spaceid}/page/${item.item_id}`,
        lastVisited: `Updated on ${new Date(item.updated_at).toLocaleString()}`,
      }));

      setData(formatted);
    } catch (err) {
      console.error('Error fetching starred content', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStarrenContent();
  }, [spaceid]);

const filteredData = data.filter((item) => {
  const title = item.title || '';
  return title.toLowerCase().includes(search.toLowerCase());
});

  return (
    <div style={{ padding: '24px' }}>
      <h1 style={{ marginBottom: 20 }}>Starred</h1>

      <Input
        placeholder="Filter by title"
        style={{ width: 300, marginBottom: 20 }}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      {loading ? (
        <div
          style={{
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SkeletonWithLoaders size="large" />
        </div>
      ) : (
        <List
          bordered
          dataSource={filteredData}
          locale={{
            emptyText: 'No starred pages',
          }}
          renderItem={(item) => (
            <List.Item
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderRadius: 8,
                marginBottom: 10,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div
                  style={{
                    width: 40,
                    height: 40,
                    border: '1px solid #e5e7eb',
                    borderRadius: 6,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <FileTextOutlined />
                </div>

                <div>
                  <Text
                    strong
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate(item.pageUrl)}
                  >
                    {item.title}
                  </Text>
                  <br />
                  <Text
                    type="secondary"
                    style={{
                      textTransform: 'capitalize',
                    }}
                  >
                    {item.item_type}
                  </Text>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                {item.starred ? (
                  <StarFilled
                    style={{ color: '#faad14', cursor: 'pointer' }}
                    onClick={() => handleStarToggle(item.id)}
                  />
                ) : (
                  <StarOutlined
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleStarToggle(item.id)}
                  />
                )}

                <Text type="secondary">{item.lastVisited}</Text>
              </div>
            </List.Item>
          )}
        />
      )}
    </div>
  );
};

export default StarredPages;
